import React from 'react';
interface SectionHeadingProps {
  eyebrow?: string;
  title: React.ReactNode;
  titleId?: string;
  lead?: React.ReactNode;
  className?: string;
}

/** Centered serif heading: navy title, optional small eyebrow and lead. */
export function SectionHeading({
  eyebrow,
  title,
  titleId,
  lead,
  className = ''
}: SectionHeadingProps) {
  return <div className={`mx-auto max-w-3xl text-center ${className}`} data-id="element-222" data-mp="3k0f8rjskrt8e">
      {eyebrow ? <p className="text-xs font-bold uppercase tracking-widest text-gold-text" data-id="element-223" data-mp="blohl8fx4c55">
          {eyebrow}
        </p> : null}
      <h2 id={titleId} className={`font-display text-3xl font-bold leading-tight text-navy sm:text-4xl lg:text-5xl ${eyebrow ? 'mt-3' : ''}`} data-id="element-224" data-mp="giorxvjsw122">
        {title}
      </h2>
      {lead ? <p className="mx-auto mt-4 max-w-2xl text-base leading-relaxed text-body" data-id="element-225" data-mp="6sc51woijvsr">
          {lead}
        </p> : null}
    </div>;
}